export default __webpack_public_path__ + "static/media/ansys.c1c463a9.jpg";